import Component from './concave-radius-box.vue';
export default Component;
